export default __webpack_public_path__ + "static/media/right-arrow-orange.6e880e74.svg";